import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    text: 'Leí este libro y sentí que me quitaban una venda de los ojos. Entendí por qué siempre me sentía estancado. Mi forma de ver el mundo cambió para siempre.',
    author: 'Carlos M.',
    role: 'Emprendedor'
  }, {
    text: 'Profundo, directo y sin filtros. Su lectura me llevó a cuestionar sobre todo lo que hasta hoy daba por sentado. Es literalmente un libro transformador que logra un cambio interno, al comprender la realidad de las cosas.',
    author: 'Elena R.',
    role: 'Diseñadora'
  }, {
    text: 'Llevaba años buscando respuestas en la espiritualidad tradicional, pero este enfoque sobre la realidad como un sistema codificado hizo que todo encajara.',
    author: 'David T.',
    role: 'Desarrollador'
  }];
  return <section className="py-16 md:py-24 bg-matrix-dark relative px-4" data-id="element-174">
      <div className="max-w-6xl mx-auto" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12 md:mb-16" data-id="element-176">
          <h2 className="font-cinzel text-3xl md:text-5xl text-matrix-cream mb-4" data-id="element-177">
            Voces de los Despiertos
          </h2>
          <p className="text-matrix-white/70 text-base md:text-lg" data-id="element-178">
            Quienes ya decidieron salir del juego
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-179">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-matrix-black p-6 md:p-8 rounded-lg border border-matrix-green/20 relative group hover:border-matrix-green/60 transition-colors" data-id="element-180">
              <Quote className="text-matrix-green/20 absolute top-6 right-6 w-10 h-10 md:w-12 md:h-12 group-hover:text-matrix-green/40 transition-colors" data-id="element-181" />
              <p className="text-matrix-white font-light italic mb-6 md:mb-8 relative z-10 text-base md:text-lg" data-id="element-182">
                "{testimonial.text}"
              </p>
              <div className="flex items-center gap-4" data-id="element-183">
                <div className="w-10 h-10 rounded-full bg-matrix-green/20 flex items-center justify-center text-matrix-green font-bold font-cinzel" data-id="element-184">
                  {testimonial.author.charAt(0)}
                </div>
                <div data-id="element-185">
                  <div className="text-matrix-cream font-medium" data-id="element-186">
                    {testimonial.author}
                  </div>
                  <div className="text-matrix-green text-xs md:text-sm" data-id="element-187">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}